import { PageHeader, Popconfirm,Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";
import AgregarEtapa from "./AgregarEtapa/AgregarEtapa";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import EditarEtapa from "./EditarEtapa/EditarEtapa";


class Etapas extends Component {
  state = {
    todasetapas: [],
    loading: false,
    valor: 1,
    modalAgregarEtapas: false,
    modalEditarEtapas: false,
    etapasOptions: [],
    etapaId: null,
  };

  abrirModalAgregarEtapas = () => {
    this.setState({ modalAgregarEtapas: true });
  };
  
  cerrarModalAgregarEtapas = () => {
    this.setState({ modalAgregarEtapas: false });
    this.consultarEtapas(this.state.valor);
  };

  abrirModalEditarEtapas = (id) => {
    this.setState({ modalEditarEtapas: true, etapaId: id });
  };

  cerrarModalEditarEtapas = () => {
    this.setState({ modalEditarEtapas: false, etapaId: null });
    this.consultarEtapas(this.state.valor);
  };

  deshabilitarEtapa = (id) => {
    axios
        .post(
            "etapas/deshabilitarEtapa",
            { etapaId: id, empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        )
        .then((res) => {
            if (res.data.success === 2) {
                message.success("Etapa deshabilitada correctamente");
            } else {
                message.error("Error al deshabilitar la etapa");
            }
            this.consultarEtapas(this.state.valor);
        })
        .catch((error) => {
            console.error("Error al deshabilitar la etapa:", error);
            message.error("Error al deshabilitar la etapa");
        });
    };

    habilitarEtapa = (id) => {
    axios
        .post(
            "etapas/habilitarEtapa",
            { etapaId: id, empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        )
        .then((res) => {
            if (res.data.success === 2) {
                message.success("Etapa habilitada correctamente");
            } else {
                message.error("Error al habilitar la etapa");
            }
            this.consultarEtapas(this.state.valor);
        })
        .catch((error) => {
            console.error("Error al habilitar la etapa:", error);
            message.error("Error al habilitar la etapa");
        });
    };
    

  componentDidMount() {
    this.consultarEtapas(this.state.valor);
  }

  consultarEtapas = (valor) => {
    this.setState({ loading: true });

    axios
      .post(
        "etapas/selectTodasEtapas",
        {
          empresaId: this.props.empresaId,
          valor: valor,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });

        if(res.data.success === 2) {
          if (res.data.etapas && res.data.etapas.length > 0) {
            this.setState({ todasetapas: res.data.etapas });
          } else {
            this.setState({ todasetapas: [] });
          }
        }

      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar etapas:", error);
        message.error("Error al cargar las etapas");
      });
  };

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
        buscar: "descripcion",
      },
      {
        title: "Etapa anterior",
        dataIndex: "etapaAnterior",
        key: "etapaAnterior",
        align: "center",
        render: (etapas) =>
          etapas && etapas.length
            ? etapas.map((e) => e.nombre).join(", ")
            : "Ninguno",
      },
      {
        title: "Etapa siguiente",
        dataIndex: "etapaSiguiente",
        key: "etapaSiguiente",
        align: "center",
        render: (etapas) =>
          etapas && etapas.length
            ? etapas.map((e) => e.nombre).join(", ")
            : "Ninguno",
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (text, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip 
              title="Editar Etapa" 
              placement="top"
            >
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirModalEditarEtapas(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // Botón Habilitar/Deshabilitar con Popconfirm
          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar esta etapa?"
                onConfirm={() => this.deshabilitarEtapa(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar esta etapa?"
                onConfirm={() => this.habilitarEtapa(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top">
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      }
    ];

    return (
      <>
        <PageHeader
          title="Etapas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Activo", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    this.consultarEtapas(value);
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem type="primary"  className="botonAgregar" olivo onClick={this.abrirModalAgregarEtapas}>
                Agregar Etapa
              </ButtonItem>
            </>
          }
        />

        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasetapas}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => {
              console.log("Editar etapa:", record._id);
            },
          })}
        />

        <AgregarEtapa
          visible={this.state.modalAgregarEtapas}
          cerrarModal={this.cerrarModalAgregarEtapas}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          onEtapaAdded={() => this.consultarEtapas(this.state.valor)}
        />
        <EditarEtapa
          visible={this.state.modalEditarEtapas}
          cerrarModal={this.cerrarModalEditarEtapas}
          etapaId={this.state.etapaId}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Etapas);
